/** Concatène les parties non vides d'une adresse (ex : adresse, ville). */
export const joinAddress = (...parts) => parts.filter(Boolean).join(", ");
